<app-pills-overflow
  class="w-full min-w-0"
  [items]="pillItems()"
  [maxRows]="3"
  [pillHeight]="24"
  [gapSize]="6">
  <ng-template #pillTemplate let-item let-clickable="clickable">
    @if (clickable && filterable()) {
      <button
        type="button"
        class="group/tag hover:border-accent-border inline-flex max-w-full cursor-pointer rounded-full border border-transparent transition-all"
        (mouseenter)="onPillHover(item)"
        (mouseleave)="onPillHoverEnd()"
        (click)="$event.stopPropagation(); onPillClick(item)">
        <!-- `!` because the tag tints its own background through an inline style. -->
        <app-custom-tag
          class="group-hover/tag:bg-accent-interactive!"
          [color]="item.data.color"
          [label]="item.data.label" />
      </button>
    } @else {
      <app-custom-tag [color]="item.data.color" [label]="item.data.label" />
    }
  </ng-template>
</app-pills-overflow>
